import { FlowState } from 'common/interfaces'

export const DEFAULT_RESTART_BUTTON_LABEL = 'New claim'

export function getRestartButtonLabel(
  flow?: Pick<FlowState, 'restart_button_label'>
): string {
  const label = flow?.restart_button_label?.trim()
  return label !== undefined && label !== '' ? label : DEFAULT_RESTART_BUTTON_LABEL
}
